import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  COLLECTIONS_INDEX_REQUESTED,
  COLLECTIONS_INDEX_SUCCESS,
  COLLECTIONS_INDEX_FAILURE,
} from '../types';

export const collectionsIndexRequested = () => {
  return {
    type: COLLECTIONS_INDEX_REQUESTED
  }
};

export const collectionsIndexSuccess = (collections) => {
  return {
    type: COLLECTIONS_INDEX_SUCCESS,
    payload: collections
  }
};

export const collectionsIndexFailure = () => {
  return {
    type: COLLECTIONS_INDEX_FAILURE
  }
};

export const collectionsIndex = (term = '') => {
  return async (dispatch) => {
    dispatch(collectionsIndexRequested());

    const endPoint = Config.baseUrl + Config.collections;

    return Axios.get(endPoint, {
      headers: await authHeaders(),
      params: { term: term }
    })
      .then((response) => {
        dispatch(collectionsIndexSuccess(response.data));
      })
      .catch(() => {
        dispatch(collectionsIndexFailure());
      });
  }
}
